export default __webpack_public_path__ + "725c6caf2e088fc73d33c889db243e0e.png";